import { useMutation, useQueryClient } from 'react-query';
import { batchUpdateTradingPhotoCards } from '../apis/batchUpdateTradingPhotoCards';
import { QUERY_KEYS } from '../constants/QueryKeys';

export const useBatchUpdateTradingPhotoCardsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: batchUpdateTradingPhotoCards,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.tradingPhotoCardsAll('sale') });
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.tradingPhotoCardsAll('exchange') });
    }
  });
};
